import { zip } from 'fflate';

// Blob downloads still require a final in-memory archive. Bound that fallback
// independently of the server's planning limit and compress off the UI thread.
export const MAX_BROWSER_ZIP_BYTES = 64 * 1024 * 1024;

export function browserZipLimit(serverLimit = MAX_BROWSER_ZIP_BYTES) {
  return typeof serverLimit === 'number' && Number.isFinite(serverLimit)
    ? Math.max(0, Math.min(serverLimit, MAX_BROWSER_ZIP_BYTES))
    : MAX_BROWSER_ZIP_BYTES;
}

export function createBoundedZip(files: Record<string, Uint8Array>, limit = MAX_BROWSER_ZIP_BYTES): Promise<Uint8Array> {
  const cap = browserZipLimit(limit);
  const size = Object.values(files).reduce((total, bytes) => total + bytes.byteLength, 0);
  if (size > cap) return Promise.reject(new Error(`ZIP content exceeds the browser download limit by ${size - cap} bytes`));
  return new Promise((resolve, reject) => zip(files, { level: 6 }, (error, bytes) => {
    if (error) reject(error);
    else if (bytes.byteLength > cap) reject(new Error(`ZIP exceeds the browser download limit by ${bytes.byteLength - cap} bytes`));
    else resolve(bytes);
  }));
}
